// Press-and-hold auto-repeat for nudge controls (buttons and keys).
//
// Timing: one immediate step on press, repeats start after `initialDelayMs`
// at `intervalMs`, and the step size grows with how long the control has
// been held (1s, then 5s after 2s, then 15s after 4s by default).
export const NUDGE_SCHEDULE = [
	{ afterMs: 0, step: 1 },
	{ afterMs: 2000, step: 5 },
	{ afterMs: 4000, step: 15 },
];

export function stepForElapsed(elapsedMs, schedule = NUDGE_SCHEDULE) {
	let step = schedule[0].step;
	for (const s of schedule) {
		if (elapsedMs >= s.afterMs) step = s.step;
	}
	return step;
}

export function createHoldRepeater({ onStep, onStart, onEnd, initialDelayMs = 400, intervalMs = 100, schedule = NUDGE_SCHEDULE }) {
	let delayTimer = null;
	let intervalTimer = null;
	let startedAt = 0;
	let active = null; // { dir, ...meta }

	function tick() {
		if (!active) return;
		onStep(stepForElapsed(Date.now() - startedAt, schedule) * active.dir, active);
	}

	// `dir` is +1 / -1; `firstStep` (seconds) is applied immediately.
	function start(dir, meta = {}, firstStep = 1) {
		stop(false);
		active = { dir, ...meta };
		startedAt = Date.now();
		onStart?.(active);
		onStep(firstStep * dir, active);
		delayTimer = setTimeout(() => {
			intervalTimer = setInterval(tick, intervalMs);
		}, initialDelayMs);
	}

	function stop(notify = true) {
		clearTimeout(delayTimer);
		clearInterval(intervalTimer);
		delayTimer = null;
		intervalTimer = null;
		const was = active;
		active = null;
		if (was && notify) onEnd?.(was);
	}

	return { start, stop, isActive: () => active !== null };
}
